export default "__VITE_ASSET__C5b6l_dD__"